import { render, staticRenderFns } from "./public-holiday.vue?vue&type=template&id=11dd2dd4&"
import script from "./public-holiday.vue?vue&type=script&lang=js&"
export * from "./public-holiday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports